import React from "react";
import { MapPin, Phone, Mail, Facebook, Instagram, ArrowUp } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { company, services } from "../mock";

const Footer = () => {
  const { t, lang } = useLang();
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer className="bg-[var(--zd-ink)] text-white pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <div className="inline-flex items-center bg-white rounded-xl px-4 py-3">
              <img src={company.logo} alt="ZD Consulting 正大律师事务所" className="h-11 w-auto object-contain" />
            </div>
            <p className={`mt-5 text-sm text-white/60 leading-relaxed ${lang === "zh" ? "font-zh" : ""}`}>{t.footer.tagline}</p>
            <div className="mt-5 flex items-center gap-3">
              <a href={company.social.facebook} target="_blank" rel="noreferrer" className="h-9 w-9 rounded-full grid place-items-center bg-white/10 hover:bg-[var(--zd-red)] transition-colors"><Facebook className="h-4 w-4" /></a>
              <a href={company.social.instagram} target="_blank" rel="noreferrer" className="h-9 w-9 rounded-full grid place-items-center bg-white/10 hover:bg-[var(--zd-red)] transition-colors"><Instagram className="h-4 w-4" /></a>
              <a href={company.social.xiaohongshu} target="_blank" rel="noreferrer" className="h-9 px-3 rounded-full grid place-items-center bg-white/10 hover:bg-[var(--zd-red)] transition-colors font-zh text-xs font-bold">小红书</a>
            </div>
          </div>

          <div>
            <h4 className={`font-display font-semibold mb-4 ${lang === "zh" ? "font-zh" : ""}`}>{t.nav.services}</h4>
            <ul className="space-y-2.5">
              {services.slice(0, 6).map((s) => (
                <li key={s.id}>
                  <button onClick={() => scrollTo("servicios")} className={`text-sm text-white/60 hover:text-white transition-colors text-left ${lang === "zh" ? "font-zh" : ""}`}>{s[lang].title}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className={`font-display font-semibold mb-4 ${lang === "zh" ? "font-zh" : ""}`}>{t.nav.services}</h4>
            <ul className="space-y-2.5">
              {services.slice(6).map((s) => (
                <li key={s.id}>
                  <button onClick={() => scrollTo("servicios")} className={`text-sm text-white/60 hover:text-white transition-colors text-left ${lang === "zh" ? "font-zh" : ""}`}>{s[lang].title}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className={`font-display font-semibold mb-4 ${lang === "zh" ? "font-zh" : ""}`}>{t.nav.contact}</h4>
            <ul className="space-y-3.5">
              <li className="flex items-start gap-3 text-sm text-white/60"><MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" style={{ color: "var(--zd-gold)" }} />{company.address}</li>
              <li className="flex items-center gap-3 text-sm text-white/60"><Phone className="h-4 w-4 flex-shrink-0" style={{ color: "var(--zd-gold)" }} /><a href={`tel:${company.phoneRaw}`} className="hover:text-white transition-colors">{company.phone}</a></li>
              <li className="flex items-center gap-3 text-sm text-white/60"><Mail className="h-4 w-4 flex-shrink-0" style={{ color: "var(--zd-gold)" }} /><a href={`mailto:${company.email}`} className="hover:text-white transition-colors">{company.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/50">© {new Date().getFullYear()} ZD Consulting · 正大律师事务所. {t.footer.rights}</p>
          <button onClick={scrollTop} className="inline-flex items-center gap-2 text-sm text-white/60 hover:text-white transition-colors">
            <ArrowUp className="h-4 w-4" /> Top
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
